import { proxy } from "valtio";

export interface APIDataProps {
  globals?: any;
  regions?: any;
  countries?: Record<string, CountryData>;
  fetchingTopLevelData?: boolean;
  fetchingCountryData?: boolean;
  fetchingDocuments?: boolean;
}

interface CountryData {
  vulnerability: number;
  subRegion: string;
  regionCode: string;
  region: string;
  prevalence: number;
  name: string;
  recommendations: Recommendation[];
  recommendations_date: string;
  iso: string;
  imports: any[];
  id: string;
  govresponse: number;
  documents: Document[];
  coordinates: [any];
  links: any[];
  fetched: boolean;
}

interface Recommendation {
  copy: string;
  title: string;
}

const apiData: APIDataProps = proxy({
  fetchingTopLevelData: true,
  fetchingCountryData: false,
  fetchingDocuments: true,
  globals: {
    worldwide_prevalence_data: null,
    worldwide_prevalence_statement: null,
    download_urls: [],
    tooltips: {
      prevalence: null,
      vulnerability: null,
      govt_response: null,
      grading: null,
      legend: null,
      country_table_heading: null
    },
    documents: []
  },
  regions: {},
  countries: {}
});

export default apiData;
